import { MAX_HP } from "../../../constants.js";

const CONTROL_LEGEND_TEXT = "Arrows: move\nSpace: jump\nF: slide\nD: slash\nA: throw\nS: kick\nR: respawn";
const CHAT_DEFAULT_MAX_LINES = 8;
const CHAT_DEFAULT_MAX_TEXT_LENGTH = 140;
const CHAT_HUD_DEPTH = 5000;
const TOP_UI_DEPTH = CHAT_HUD_DEPTH + 20;
const CHAT_LINE_HEIGHT = 16;
const CHAT_LINE_PADDING = 6;
const CHAT_COLLAPSED_LINES = 2;
const CHAT_COLLAPSED_PADDING = 10;
const SCOREBOARD_PANEL_MIN_WIDTH = 340;
const SCOREBOARD_PANEL_MAX_WIDTH = 620;
const SCOREBOARD_MAX_ROWS = 10;
const SCOREBOARD_LINE_HEIGHT = 14;
const SCOREBOARD_PADDING = 8;
const SCOREBOARD_PANEL_X_PADDING = 12;
const SCOREBOARD_CHAR_WIDTH_APPROX = 7;
const SCOREBOARD_NAME_WIDTH = 24;
const SCOREBOARD_PLAYER_KILLS_WIDTH = 12;
const SCOREBOARD_PLAYER_DEATHS_WIDTH = 16;
const SCOREBOARD_ENEMY_KILLS_WIDTH = 12;
const SCOREBOARD_ENEMY_DEATHS_WIDTH = 16;
const SCOREBOARD_NAME_HEADER = "Players";
const SCOREBOARD_PLAYER_KILLS_HEADER = "Player Kills";
const SCOREBOARD_PLAYER_DEATHS_HEADER = "Deaths by Player";
const SCOREBOARD_ENEMY_KILLS_HEADER = "Enemy Kills";
const SCOREBOARD_ENEMY_DEATHS_HEADER = "Deaths by Enemy";
const SCOREBOARD_OFFLINE_SECTION_OPEN = "\u25BC";
const SCOREBOARD_OFFLINE_SECTION_CLOSED = "\u25B6";
const SCOREBOARD_SHOW_OFFLINE_SECTION = false;

export function createHUDController(scene, {
  viewW,
  viewH,
  centerX,
  onProfileEdit = () => {},
  onLoadingTest = () => {},
}) {
  const controller = {
    profileMenuOpen: false,
  };

  const hpBar = scene.add.graphics().setDepth(1200);
  const menuButtonBg = scene.add.rectangle(10, 8, 72, 24, 0x000000, 0.5)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(TOP_UI_DEPTH)
    .setInteractive({ useHandCursor: true });
  const menuButtonText = scene.add.text(46, 20, "Menu", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.9)",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(TOP_UI_DEPTH + 1).setInteractive({ useHandCursor: true });
  const scoreboardButtonBg = scene.add.rectangle(86, 8, 98, 24, 0x1f2937, 0.7)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(TOP_UI_DEPTH)
    .setInteractive({ useHandCursor: true });
  const scoreboardButtonText = scene.add.text(135, 20, "Scoreboard", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.9)",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(TOP_UI_DEPTH + 1).setInteractive({ useHandCursor: true });
  const loadTestButtonBg = scene.add.rectangle(186, 8, 84, 24, 0x1f2937, 0.7)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(TOP_UI_DEPTH)
    .setInteractive({ useHandCursor: true });
  const loadTestButtonText = scene.add.text(228, 20, "Load", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.9)",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(TOP_UI_DEPTH + 1).setInteractive({ useHandCursor: true });
  loadTestButtonBg.setVisible(false);
  loadTestButtonText.setVisible(false);
  loadTestButtonBg.removeInteractive();
  loadTestButtonText.removeInteractive();

  const profileMenuBg = scene.add.rectangle(10, 38, 280, 192, 0x000000, 0.65)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(TOP_UI_DEPTH + 2)
    .setVisible(false);
  const profileMenuText = scene.add.text(20, 48, CONTROL_LEGEND_TEXT, {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.86)",
    lineSpacing: 2,
  }).setScrollFactor(0).setDepth(TOP_UI_DEPTH + 3).setVisible(false);
  const profileMenuEditBg = scene.add.rectangle(20, 194, 136, 26, 0x2563eb, 0.9)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(TOP_UI_DEPTH + 3)
    .setVisible(false)
    .setInteractive({ useHandCursor: true });
  const profileMenuEditText = scene.add.text(88, 207, "Edit Profile", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#ffffff",
    fontStyle: "bold",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(TOP_UI_DEPTH + 4).setVisible(false).setInteractive({ useHandCursor: true });

  const interactText = scene.add.text(centerX, viewH - 36, "Press Up to enter", {
    fontFamily: "monospace",
    fontSize: "14px",
    color: "rgba(255,255,255,0.82)",
    stroke: "#000000",
    strokeThickness: 3,
  }).setOrigin(0.5, 1).setScrollFactor(0).setDepth(103).setVisible(false);

  const deathOverlay = scene.add.graphics().setScrollFactor(0).setDepth(6000).setVisible(false);
  const deathText1 = scene.add.text(centerX, viewH * 0.47, "YOU DIED", {
    fontFamily: "monospace", fontSize: "36px", color: "#ff4444",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(6100).setVisible(false);
  const deathText2 = scene.add.text(centerX, viewH * 0.53, "Press R to respawn", {
    fontFamily: "monospace", fontSize: "16px", color: "rgba(255,255,255,0.7)",
  }).setOrigin(0.5).setScrollFactor(0).setDepth(6100).setVisible(false);

  const netStatusText = scene.add.text(viewW - 10, 8, "NET: offline", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(150,190,255,0.8)",
  }).setOrigin(1, 0).setScrollFactor(0).setDepth(100);
  const netServerText = scene.add.text(viewW - 10, 24, "Server: n/a", {
    fontFamily: "monospace",
    fontSize: "10px",
    color: "rgba(180,210,255,0.72)",
    align: "right",
  }).setOrigin(1, 0).setScrollFactor(0).setDepth(101);
  const netDebugText = scene.add.text(viewW - 10, 38, "", {
    fontFamily: "monospace",
    fontSize: "10px",
    color: "rgba(180,210,255,0.55)",
    align: "right",
    wordWrap: { width: 340 },
  }).setOrigin(1, 0).setScrollFactor(0).setDepth(102).setVisible(false);

  const chatPanelWidth = Math.max(300, Math.min(viewW - 20, 520));
  const chatPanelHeightExpanded = CHAT_DEFAULT_MAX_LINES * 18 + 10;
  const chatPanelHeightCollapsed = CHAT_COLLAPSED_LINES * CHAT_LINE_HEIGHT + CHAT_COLLAPSED_PADDING;
  const chatPanelX = 10;
  const chatInputY = viewH - 36;
  const chatPanelY = chatInputY - 8;

  let chatOpen = false;
  let chatHistory = [];
  let chatInputValue = "";
  let chatMaxLines = CHAT_DEFAULT_MAX_LINES;
  let chatCollapsed = false;
  let chatLineObjects = [];

  const chatPanelBg = scene.add.rectangle(chatPanelX, chatPanelY - chatPanelHeightExpanded, chatPanelWidth, chatPanelHeightExpanded, 0x000000, 0.55)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(CHAT_HUD_DEPTH)
    .setVisible(false);
  const chatHintText = scene.add.text(chatPanelX + 10, chatPanelY - chatPanelHeightExpanded - 14, "Press C to collapse chat", {
    fontFamily: "monospace",
    fontSize: "10px",
    color: "rgba(180,200,230,0.45)",
  }).setOrigin(0, 1).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 4).setVisible(false);
  const chatInputBg = scene.add.rectangle(chatPanelX, chatInputY, chatPanelWidth, 22, 0x111827, 0.8)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(CHAT_HUD_DEPTH + 2)
    .setVisible(false);
  const chatInputPrefix = scene.add.text(chatPanelX + 8, chatInputY + 5, ">", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.9)",
  }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 3).setVisible(false);
  const chatInputText = scene.add.text(chatPanelX + 16, chatInputY + 5, "", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,255,255,0.95)",
  }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 3).setVisible(false);
  const chatInputHint = scene.add.text(chatPanelX + 16, chatInputY + 5, "Type a message...", {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(180,200,230,0.65)",
  }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 3).setVisible(false);

  const otherChatStyle = {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(220,236,255,0.95)",
    fontStyle: "normal",
    lineSpacing: 2,
    wordWrap: { width: chatPanelWidth - 16 },
  };
  const selfChatStyle = {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#7fffd4",
    fontStyle: "bold",
    lineSpacing: 2,
    wordWrap: { width: chatPanelWidth - 16 },
  };
  const systemChatStyle = {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "rgba(255,204,102,0.92)",
    fontStyle: "bold",
    lineSpacing: 2,
    wordWrap: { width: chatPanelWidth - 16 },
  };

  const clampValue = (value, min, max) => Math.max(min, Math.min(max, value));
  const formatServerLabel = (wsUrl) => {
    const raw = typeof wsUrl === "string" ? wsUrl.trim() : "";
    if (!raw || raw === "n/a") return "n/a";
    try {
      const parsed = new URL(raw);
      return parsed.host || parsed.hostname || "n/a";
    } catch {
      return raw.length > 42 ? `${raw.slice(0, 20)}...${raw.slice(-18)}` : raw;
    }
  };
  let scoreboardPanelWidth = clampValue(viewW - 20, SCOREBOARD_PANEL_MIN_WIDTH, SCOREBOARD_PANEL_MAX_WIDTH);
  let scoreboardX = Math.round((viewW - scoreboardPanelWidth) / 2);
  const scoreboardY = 8;
  let scoreboardOpen = false;
  let scoreboardRows = [];
  let scoreboardOfflineRows = [];
  let scoreboardOfflineOpen = false;
  let scoreboardLocalPlayerId = null;
  let scoreboardSnapshotSignature = "";
  const scoreboardBg = scene.add.rectangle(scoreboardX, scoreboardY, scoreboardPanelWidth, 44, 0x05070f, 0.75)
    .setOrigin(0, 0)
    .setScrollFactor(0)
    .setDepth(CHAT_HUD_DEPTH + 1)
    .setVisible(false);
  const scoreboardHeader = scene.add.text(scoreboardX + SCOREBOARD_PADDING, scoreboardY + SCOREBOARD_PADDING, "", {
    fontFamily: "monospace",
    fontSize: "10px",
    color: "rgba(170,220,255,0.9)",
    fontStyle: "bold",
  }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 2).setVisible(false);
  let scoreboardLineObjects = [];

  const formatStatsValue = (value) => String(Math.max(0, Number.isFinite(Number(value)) ? Math.floor(Number(value)) : 0)).padStart(2, " ");

  const formatScoreboardCell = (value, width, align = "right") => {
    const text = String(value ?? "").padEnd(width, " ");
    if (align === "left") {
      return text.slice(0, width);
    }
    return text.trim().padStart(width, " ").slice(-width);
  };

  const formatScoreboardRowText = (entry) => {
    const name = formatScoreboardCell(entry?.name || "Player", SCOREBOARD_NAME_WIDTH, "left");
    const playerKills = formatScoreboardCell(formatStatsValue(entry.playerKills), SCOREBOARD_PLAYER_KILLS_WIDTH, "right");
    const playerDeaths = formatScoreboardCell(formatStatsValue(entry.playerDeaths), SCOREBOARD_PLAYER_DEATHS_WIDTH, "right");
    const enemyKills = formatScoreboardCell(formatStatsValue(entry.enemyKills), SCOREBOARD_ENEMY_KILLS_WIDTH, "right");
    const enemyDeaths = formatScoreboardCell(formatStatsValue(entry.enemyDeaths), SCOREBOARD_ENEMY_DEATHS_WIDTH, "right");
    return `${name}  ${playerKills}  ${playerDeaths}  ${enemyKills}  ${enemyDeaths}`;
  };

  const formatScoreboardHeader = (onlineCount = 0) => {
    const count = Number.isFinite(Number(onlineCount)) ? Math.max(0, Math.floor(Number(onlineCount))) : 0;
    const nameHeader = `${SCOREBOARD_NAME_HEADER} (${count})`;
    return `${formatScoreboardCell(nameHeader, SCOREBOARD_NAME_WIDTH, "left")}  ` +
    `${formatScoreboardCell(SCOREBOARD_PLAYER_KILLS_HEADER, SCOREBOARD_PLAYER_KILLS_WIDTH, "right")}  ` +
    `${formatScoreboardCell(SCOREBOARD_PLAYER_DEATHS_HEADER, SCOREBOARD_PLAYER_DEATHS_WIDTH, "right")}  ` +
    `${formatScoreboardCell(SCOREBOARD_ENEMY_KILLS_HEADER, SCOREBOARD_ENEMY_KILLS_WIDTH, "right")}  ` +
    `${formatScoreboardCell(SCOREBOARD_ENEMY_DEATHS_HEADER, SCOREBOARD_ENEMY_DEATHS_WIDTH, "right")}`;
  };

  const formatOfflineHeaderText = (count) => `${scoreboardOfflineOpen ? SCOREBOARD_OFFLINE_SECTION_OPEN : SCOREBOARD_OFFLINE_SECTION_CLOSED} OFFLINE (${count})`;

  const calcScoreboardWidth = (rows, offlineRows, headerText, offlineHeaderText) => {
    const maxRowChars = rows.reduce((acc, row) => {
      return Math.max(acc, formatScoreboardRowText(row).length);
    }, 0);
    const maxOfflineRowChars = offlineRows.reduce((acc, row) => {
      return Math.max(acc, formatScoreboardRowText(row).length);
    }, 0);
    const neededChars = Math.max(
      headerText.length,
      maxRowChars,
      maxOfflineRowChars,
      offlineHeaderText ? offlineHeaderText.length : 0,
      SCOREBOARD_NAME_WIDTH,
    );
    const minContentWidth = neededChars * SCOREBOARD_CHAR_WIDTH_APPROX;
    const widthWithPadding = minContentWidth + SCOREBOARD_PANEL_X_PADDING * 2 + SCOREBOARD_PADDING * 2;
    return clampValue(Math.ceil(widthWithPadding), SCOREBOARD_PANEL_MIN_WIDTH, Math.min(viewW - 20, SCOREBOARD_PANEL_MAX_WIDTH));
  };

  const normalizePlayerId = (value) => {
    if (value === null || value === undefined) return "";
    return String(value);
  };
  const buildScoreboardRows = (inputRows, maxRows = SCOREBOARD_MAX_ROWS) => {
    const rows = Array.isArray(inputRows) ? inputRows : [];
    const normalized = rows.map((entry) => ({
      ...entry,
      id: normalizePlayerId(entry?.id),
      name: typeof entry?.name === "string" ? entry.name : "Player",
      displayName: typeof entry?.displayName === "string" ? entry.displayName : typeof entry?.name === "string" ? entry.name : "Player",
      playerKills: Number.isFinite(Number(entry?.playerKills)) ? Math.max(0, Math.floor(Number(entry.playerKills))) : 0,
      playerDeaths: Number.isFinite(Number(entry?.playerDeaths)) ? Math.max(0, Math.floor(Number(entry.playerDeaths))) : 0,
      enemyKills: Number.isFinite(Number(entry?.enemyKills)) ? Math.max(0, Math.floor(Number(entry.enemyKills))) : 0,
      enemyDeaths: Number.isFinite(Number(entry?.enemyDeaths)) ? Math.max(0, Math.floor(Number(entry.enemyDeaths))) : 0,
    }));
    normalized.sort((a, b) => {
      if (b.playerKills !== a.playerKills) return b.playerKills - a.playerKills;
      if (a.playerDeaths !== b.playerDeaths) return a.playerDeaths - b.playerDeaths;
      if (b.enemyKills !== a.enemyKills) return b.enemyKills - a.enemyKills;
      return (a.name || "").localeCompare(b.name || "");
    });
    return maxRows != null && maxRows > 0 ? normalized.slice(0, maxRows) : normalized;
  };

  const renderScoreboard = () => {
    for (const line of scoreboardLineObjects) line.destroy();
    scoreboardLineObjects = [];

    const rows = buildScoreboardRows(scoreboardRows);
    const offlineRows = SCOREBOARD_SHOW_OFFLINE_SECTION
      ? buildScoreboardRows(scoreboardOfflineRows, Infinity)
      : [];
    const headerText = formatScoreboardHeader(rows.length);
    const offlineHeaderText = offlineRows.length > 0 ? formatOfflineHeaderText(offlineRows.length) : "";
    const panelHeaderText = `${headerText}`;
    scoreboardPanelWidth = calcScoreboardWidth(rows, offlineRows, panelHeaderText, offlineHeaderText);
    scoreboardX = Math.round((viewW - scoreboardPanelWidth) / 2);
    const visible = !!scoreboardOpen;
    const visibleRows = 1 + rows.length + (offlineRows.length > 0 ? 1 : 0) + (scoreboardOfflineOpen ? offlineRows.length : 0);
    const panelHeight = visible ? Math.max(visibleRows, 1) * SCOREBOARD_LINE_HEIGHT + SCOREBOARD_PADDING * 2 : 44;
    scoreboardBg.setPosition(scoreboardX, scoreboardY);
    scoreboardBg.setSize(scoreboardPanelWidth, Math.max(44, panelHeight));
    scoreboardBg.setVisible(visible);
    scoreboardHeader.setVisible(visible);
    if (visible) {
      scoreboardHeader.setPosition(scoreboardX + SCOREBOARD_PANEL_X_PADDING, scoreboardY + SCOREBOARD_PADDING);
      scoreboardHeader.setText(headerText);
    }
    if (!visible) return;

    rows.forEach((entry, index) => {
      const lineY = scoreboardY + SCOREBOARD_PADDING + 14 + index * SCOREBOARD_LINE_HEIGHT;
      const isLocal = !!entry.id && !!scoreboardLocalPlayerId && entry.id === scoreboardLocalPlayerId;
      const rowColor = isLocal ? "#7fffd4" : "rgba(220,236,255,0.95)";
      const rowFontStyle = isLocal ? "bold" : "normal";
      const rowText = formatScoreboardRowText({
        ...entry,
        name: entry.displayName || entry.name,
      });

      scoreboardLineObjects.push(
        scene.add.text(scoreboardX + SCOREBOARD_PANEL_X_PADDING, lineY, rowText, {
          fontFamily: "monospace",
          fontSize: "10px",
          color: rowColor,
          fontStyle: rowFontStyle,
        }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 2).setVisible(visible),
      );
    });

    if (offlineRows.length > 0) {
      const offlineHeaderY = scoreboardY + SCOREBOARD_PADDING + 14 + rows.length * SCOREBOARD_LINE_HEIGHT;
      const offlineText = scene.add.text(scoreboardX + SCOREBOARD_PANEL_X_PADDING, offlineHeaderY, formatOfflineHeaderText(offlineRows.length), {
        fontFamily: "monospace",
        fontSize: "10px",
        color: "rgba(245, 214, 122, 0.95)",
        fontStyle: "bold",
      }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 2).setVisible(visible).setInteractive({ useHandCursor: true });
      offlineText.on("pointerdown", () => {
        toggleOfflineScoreboard();
      });
      scoreboardLineObjects.push(offlineText);

      if (scoreboardOfflineOpen) {
        offlineRows.forEach((entry, index) => {
          const lineY = offlineHeaderY + SCOREBOARD_LINE_HEIGHT + index * SCOREBOARD_LINE_HEIGHT;
          const rowText = formatScoreboardRowText({
            ...entry,
            name: entry.displayName || entry.name,
          });
          scoreboardLineObjects.push(
            scene.add.text(scoreboardX + SCOREBOARD_PANEL_X_PADDING + 12, lineY, rowText, {
              fontFamily: "monospace",
              fontSize: "10px",
              color: "rgba(200,220,245,0.9)",
            }).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 2).setVisible(visible),
          );
        });
      }
    }
  };

  const renderChatHUD = () => {
    const lines = Array.isArray(chatHistory) ? chatHistory.slice(-chatMaxLines) : [];
    const displayLines = chatCollapsed ? lines.slice(-CHAT_COLLAPSED_LINES) : lines;
    const showIntroHint = !chatOpen && lines.length === 0;
    const showPanel = chatOpen || lines.length > 0 || chatCollapsed || showIntroHint;
    const panelHeight = (chatCollapsed || showIntroHint) ? chatPanelHeightCollapsed : chatPanelHeightExpanded;
    const panelTop = chatPanelY - panelHeight;
    const chatLineStartY = panelTop + CHAT_LINE_PADDING;
    chatPanelBg.setPosition(chatPanelX, panelTop);
    chatPanelBg.setSize(chatPanelWidth, panelHeight);
    chatHintText.setPosition(chatPanelX + 10, panelTop - 14);
    const normalizedInput = String(chatInputValue || "").slice(0, CHAT_DEFAULT_MAX_TEXT_LENGTH);

    chatPanelBg.setVisible(showPanel);
    for (const lineObj of chatLineObjects) lineObj.destroy();
    chatLineObjects = [];
    if (showPanel) {
      for (let i = 0; i < displayLines.length; i++) {
        const entry = displayLines[i];
        const isSelf = !!entry?.isSelf;
        const isSystem = !!entry?.isSystem;
        const lineStyle = isSystem ? systemChatStyle : isSelf ? selfChatStyle : otherChatStyle;
        const name = isSystem ? "SYSTEM" : (isSelf ? "You" : String(entry?.name || "Player"));
        const lineText = `${name}: ${entry?.text || ""}`;
        chatLineObjects.push(
          scene.add.text(
            chatPanelX + 8,
            chatLineStartY + i * CHAT_LINE_HEIGHT,
            lineText,
            lineStyle,
          ).setOrigin(0, 0).setScrollFactor(0).setDepth(CHAT_HUD_DEPTH + 1).setVisible(showPanel)
        );
      }
    }
    if (showIntroHint) {
      chatHintText.setText("Press (Enter) to chat");
    } else {
      chatHintText.setText(chatCollapsed ? "Press C to expand chat" : "Press C to collapse chat");
    }
    chatHintText.setVisible(showPanel);

    chatInputBg.setVisible(chatOpen);
    chatInputPrefix.setVisible(chatOpen);
    chatInputText.setVisible(chatOpen);
    chatInputHint.setVisible(chatOpen && normalizedInput.length === 0);
    chatInputText.setText(chatOpen ? normalizedInput : "");
  };

  const toggleProfileMenu = (forceOpen = null) => {
    const next = forceOpen == null ? !controller.profileMenuOpen : !!forceOpen;
    controller.profileMenuOpen = next;
    profileMenuBg.setVisible(next);
    profileMenuText.setVisible(next);
    profileMenuEditBg.setVisible(next);
    profileMenuEditText.setVisible(next);
  };
  const toggleScoreboard = (forceOpen = null) => {
    const next = forceOpen == null ? !scoreboardOpen : !!forceOpen;
    scoreboardOpen = next;
    renderScoreboard();
  };
  const toggleOfflineScoreboard = (forceOpen = null) => {
    const next = forceOpen == null ? !scoreboardOfflineOpen : !!forceOpen;
    scoreboardOfflineOpen = next;
    renderScoreboard();
  };

  const openProfileEditor = async () => {
    toggleProfileMenu(false);
    if (typeof onProfileEdit === "function") {
      await onProfileEdit();
    }
  };

  const drawHUD = (player) => {
    const p = player;
    if (!p) return;

    const g = hpBar;
    g.clear();

    const feetX = p.x + p.w / 2;
    const feetY = p.y + p.h;
    const barW = 60;
    const barH = 6;
    const radius = 3;
    const headTopY = Number.isFinite(scene.playerSprite?.getBounds?.().top)
      ? scene.playerSprite.getBounds().top
      : p.y;
    const headGap = -8;
    const barX = Math.round(feetX - barW / 2);
    const barY = Math.round(headTopY - barH - headGap);
    const fillW = Math.round((Math.max(0, p.hp) / MAX_HP) * (barW - 4));

    g.setDepth(1001 + feetY);

    g.fillStyle(0x000000, 0.55);
    g.fillRoundedRect(barX - 1, barY - 1, barW + 2, barH + 2, radius + 1);
    g.fillStyle(0x1f2937, 0.9);
    g.fillRoundedRect(barX, barY, barW, barH, radius);
    if (fillW > 0) {
      g.fillStyle(p.hp > 30 ? 0x4caf50 : 0xf44336, 1);
      g.fillRoundedRect(barX + 2, barY + 1, fillW, barH - 2, Math.max(1, radius - 1));
    }
  };

  const showDeathScreen = () => {
    deathOverlay.clear();
    deathOverlay.fillStyle(0x000000, 0.4);
    deathOverlay.fillRect(0, 0, viewW, viewH);
    deathOverlay.setVisible(true);
    deathText1.setVisible(true);
    deathText2.setVisible(true);
  };

  const hideDeathScreen = () => {
    deathOverlay.setVisible(false);
    deathText1.setVisible(false);
    deathText2.setVisible(false);
  };

  menuButtonBg.on("pointerdown", () => toggleProfileMenu());
  menuButtonText.on("pointerdown", () => toggleProfileMenu());
  scoreboardButtonBg.on("pointerdown", () => toggleScoreboard());
  scoreboardButtonText.on("pointerdown", () => toggleScoreboard());
  loadTestButtonBg.on("pointerdown", () => onLoadingTest());
  loadTestButtonText.on("pointerdown", () => onLoadingTest());
  profileMenuEditBg.on("pointerdown", () => openProfileEditor());
  profileMenuEditText.on("pointerdown", () => openProfileEditor());

  Object.assign(controller, {
    hpBar,
    menuButtonBg,
    menuButtonText,
    profileMenuBg,
    profileMenuText,
    profileMenuEditBg,
    profileMenuEditText,
    interactText,
    deathOverlay,
    deathText1,
    deathText2,
    netStatusText,
    netServerText,
    netDebugText,
    toggleProfileMenu,
    toggleScoreboard,
    openProfileEditor,
    setInteractTextVisible(value) {
      interactText.setVisible(!!value);
    },
    draw: drawHUD,
    drawChat({
      open = false,
      inputText = "",
      history = [],
      maxLines = CHAT_DEFAULT_MAX_LINES,
      collapsed = false,
    } = {}) {
      chatOpen = !!open;
      chatInputValue = typeof inputText === "string" ? inputText.slice(0, CHAT_DEFAULT_MAX_TEXT_LENGTH) : "";
      chatHistory = Array.isArray(history) ? history : [];
      chatMaxLines = Number.isFinite(maxLines) && maxLines > 0 ? Math.floor(maxLines) : CHAT_DEFAULT_MAX_LINES;
      chatCollapsed = !!collapsed;
      renderChatHUD();
    },
    setScoreboard({
      players = [],
      offlinePlayers = [],
      localPlayerId = null,
    } = {}) {
      scoreboardRows = Array.isArray(players) ? players : [];
      scoreboardOfflineRows = Array.isArray(offlinePlayers) ? offlinePlayers : [];
      scoreboardLocalPlayerId = localPlayerId != null ? String(localPlayerId) : null;
      const nextSignature = JSON.stringify({
        rows: scoreboardRows.map((entry) => ({
          id: String(entry?.id || ""),
          name: String(entry?.name || ""),
          displayName: String(entry?.displayName || ""),
          playerKills: Number(entry?.playerKills) || 0,
          playerDeaths: Number(entry?.playerDeaths) || 0,
          enemyKills: Number(entry?.enemyKills) || 0,
          enemyDeaths: Number(entry?.enemyDeaths) || 0,
        })),
        offlineRows: scoreboardOfflineRows.map((entry) => ({
          id: String(entry?.id || ""),
          name: String(entry?.name || ""),
          displayName: String(entry?.displayName || ""),
          playerKills: Number(entry?.playerKills) || 0,
          playerDeaths: Number(entry?.playerDeaths) || 0,
          enemyKills: Number(entry?.enemyKills) || 0,
          enemyDeaths: Number(entry?.enemyDeaths) || 0,
        })),
        localPlayerId: scoreboardLocalPlayerId || "",
      });
      if (nextSignature === scoreboardSnapshotSignature) return;
      scoreboardSnapshotSignature = nextSignature;
      renderScoreboard();
    },
    setNetworkDebug({
      wsUrl = "",
      playerId = null,
      sessionId = null,
      status = null,
      visible = true,
      tickRate = null,
      rttMs = null,
      remoteMotion = null,
      inputSend = null,
    } = {}) {
      const url = typeof wsUrl === "string" ? wsUrl : "";
      const resolvedUrl = url ? url : "n/a";
      const id = playerId === null || playerId === undefined ? "n/a" : String(playerId);
      const sid = sessionId === null || sessionId === undefined ? "n/a" : String(sessionId);
      const state = typeof status === "string" ? status : "";
      const statusLabel = state ? ` [${state}]` : "";
      const serverLabel = formatServerLabel(resolvedUrl);
      const maxUrlLen = 72;
      const shownUrl = resolvedUrl.length > maxUrlLen
        ? `${resolvedUrl.slice(0, 38)}...${resolvedUrl.slice(-30)}`
        : resolvedUrl;
      const tickLabel = Number.isFinite(Number(tickRate))
        ? `${Math.max(1, Math.floor(Number(tickRate)))}hz`
        : "n/a";
      const rttLabel = Number.isFinite(Number(rttMs))
        ? `${Math.max(0, Math.floor(Number(rttMs)))}ms`
        : "n/a";
      const input = (inputSend && typeof inputSend === "object") ? inputSend : null;
      const inputMs = input && Number.isFinite(Number(input.avgMs))
        ? Math.max(0, Math.round(Number(input.avgMs)))
        : 0;
      const inputHz = input && Number.isFinite(Number(input.hz))
        ? Math.max(0, Math.round(Number(input.hz)))
        : 0;
      const inputTargetMs = input && Number.isFinite(Number(input.targetMs))
        ? Math.max(1, Math.round(Number(input.targetMs)))
        : 0;
      const inputTargetHz = input && Number.isFinite(Number(input.targetHz))
        ? Math.max(1, Math.round(Number(input.targetHz)))
        : 0;
      const motion = (remoteMotion && typeof remoteMotion === "object") ? remoteMotion : null;
      const formatMs = (value) => Number.isFinite(Number(value)) ? Math.max(0, Math.round(Number(value))) : 0;
      const delayAvg = motion ? formatMs(motion.avgDelayMs) : 0;
      const delayMin = motion ? formatMs(motion.minDelayMs) : 0;
      const delayMax = motion ? formatMs(motion.maxDelayMs) : 0;
      const jitterAvg = motion ? formatMs(motion.avgJitterMs) : 0;
      const arrivalAvg = motion ? formatMs(motion.avgArrivalMs) : 0;
      const extrapRatio = motion && Number.isFinite(Number(motion.extrapolationRatio))
        ? Math.round(Math.max(0, Math.min(1, Number(motion.extrapolationRatio))) * 100)
        : 0;
      const snapsPerMinute = motion && Number.isFinite(Number(motion.snapCountLastMinute))
        ? Math.max(0, Math.floor(Number(motion.snapCountLastMinute)))
        : 0;
      const forcedSnapsFrame = motion && Number.isFinite(Number(motion.forcedSnapCountFrame))
        ? Math.max(0, Math.floor(Number(motion.forcedSnapCountFrame)))
        : 0;
      const remoteCount = motion && Number.isFinite(Number(motion.remoteCount))
        ? Math.max(0, Math.floor(Number(motion.remoteCount)))
        : 0;
      this._networkDebugVisible = !!visible;
      netServerText.setText(`Server: ${serverLabel}`);
      netDebugText.setText(
        `WS ${shownUrl}${statusLabel}\n` +
        `player:${id}  session:${sid}\n` +
        `tick:${tickLabel}  rtt:${rttLabel}\n` +
        `input:${inputMs}ms/${inputHz}hz (target ${inputTargetMs}ms/${inputTargetHz}hz)\n` +
        `remote:${remoteCount}  interp:${delayAvg}ms (${delayMin}-${delayMax})\n` +
        `arrival:${arrivalAvg}ms  jitter:${jitterAvg}ms  xtrap:${extrapRatio}%  snaps/m:${snapsPerMinute}  forced:${forcedSnapsFrame}`
      );
      netDebugText.setVisible(this._networkDebugVisible);
    },
    hideNetworkDebug() {
      netDebugText.setVisible(false);
      netDebugText.setText("");
      this._networkDebugVisible = false;
    },
    toggleNetworkDebug() {
      const next = !this._networkDebugVisible;
      this._networkDebugVisible = next;
      netDebugText.setVisible(next);
    },
    resetScoreboard() {
      scoreboardRows = [];
      scoreboardOfflineRows = [];
      scoreboardLocalPlayerId = null;
      scoreboardOfflineOpen = false;
      scoreboardSnapshotSignature = "";
      renderScoreboard();
    },
    showDeathScreen,
    hideDeathScreen,
    isChatOpen() {
      return !!chatOpen;
    },
    isChatCollapsed() {
      return !!chatCollapsed;
    },
    isProfileMenuOpen() {
      return !!controller.profileMenuOpen;
    },
  });

  renderChatHUD();
  return controller;
}
